import { useMemo } from 'react'
import { useActiveSubscriptions } from '@src/hooks/useActiveSubscriptions.ts'

export const useActiveGroupedSubscriptions = () => {
  const subscriptions = useActiveSubscriptions()

  return useMemo(() => {
    const uhcSubscriptions = subscriptions
      .filter((s) => s.primaryProduct.uhc)
      .sort((s1, s2) => Number(s2.primaryProduct.core) - Number(s1.primaryProduct.core))
    const nsSubscriptions = subscriptions
      .filter(
        (s) => !s.primaryProduct.uhc && (uhcSubscriptions.length === 0 || !s.primaryProduct.free),
      )
      .sort((s1, s2) => Number(s2.primaryProduct.core) - Number(s1.primaryProduct.core))

    return { uhcSubscriptions, nsSubscriptions }
  }, [subscriptions])
}
